<template>
    <div>
        <div v-show="loading" class="data-loader"></div>
        <list-status :size="size" v-if="data.length == 0 && !loading" title="暂无数据~"></list-status>
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: 'DataLoader',
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        data: {
            type: Array,
            default: () => []
        },
        size: {
            type: String,
            default: 'big'
        }
    }
}
</script>
<style lang="less" scoped>
.data-loader {
    margin: 0 auto;
    width: 128px;
    height: 48px;
    background: url(../../assets/loading.gif) center no-repeat;
    background-size: 100% 100%;
}
</style>
